/* TUMO: quick filter chips (available only, price ranges), orientation icons,
   EN labels for LT filter values, "prekės" -> "kūriniai" in product counts. */
(function () {
  var isLT = (document.documentElement.lang || '').toLowerCase().indexOf('lt') === 0;

  var EN = {
    'Technika': 'Technique', 'Dydis': 'Size', 'Orientacija': 'Orientation', 'Autorius': 'Artist',
    'Tapyba': 'Painting', 'Grafika': 'Graphic art', 'Skulptūra': 'Sculpture', 'Fotografija': 'Photography', 'Kita': 'Other',
    'Vertikalus': 'Portrait (vertical)', 'Horizontalus': 'Landscape (horizontal)', 'Kvadratas': 'Square',
    'Mažas (iki 50 cm)': 'Small (up to 50 cm)', 'Vidutinis (50–100 cm)': 'Medium (50–100 cm)', 'Didelis (virš 100 cm)': 'Large (over 100 cm)'
  };
  var ORI = { 'Vertikalus': 'v', 'Horizontalus': 'h', 'Kvadratas': 's', 'Portrait (vertical)': 'v', 'Landscape (horizontal)': 'h', 'Square': 's' };
  var PRICES = [[0, 600], [600, 1500], [1500, 5000], [5000, null]];

  function fmt(n) { return n.toLocaleString('lt-LT').replace(/ /g, ' '); }
  function priceLabel(r) {
    if (r[0] === 0) return (isLT ? 'iki ' : 'up to ') + fmt(r[1]) + ' €';
    if (r[1] === null) return (isLT ? 'virš ' : 'over ') + fmt(r[0]) + ' €';
    return fmt(r[0]) + '–' + fmt(r[1]) + ' €';
  }

  function go(params) {
    params.delete('page');
    var qs = params.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '') + '#main-collection-filters';
  }

  function buildChips() {
    var form = document.getElementById('FacetFiltersForm');
    if (!form || document.querySelector('.tumo-quick')) return;
    var p = new URLSearchParams(window.location.search);
    var wrap = document.createElement('div');
    wrap.className = 'tumo-quick';

    var availOn = p.getAll('filter.v.availability').indexOf('1') !== -1;
    var a = document.createElement('a');
    a.href = '#';
    a.className = 'tumo-chip' + (availOn ? ' is-on' : '');
    a.textContent = (availOn ? '✓ ' : '') + (isLT ? 'Tik laisvi' : 'Available only');
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var q = new URLSearchParams(window.location.search);
      q.delete('filter.v.availability');
      if (!availOn) q.append('filter.v.availability', '1');
      go(q);
    });
    wrap.appendChild(a);

    var lab = document.createElement('span');
    lab.className = 'tumo-quick__label';
    lab.textContent = isLT ? 'Kaina:' : 'Price:';
    wrap.appendChild(lab);

    var gte = p.get('filter.v.price.gte'), lte = p.get('filter.v.price.lte');
    PRICES.forEach(function (r) {
      var on = (gte || '') === (r[0] ? String(r[0]) : '') && (lte || '') === (r[1] !== null ? String(r[1]) : '');
      var c = document.createElement('a');
      c.href = '#';
      c.className = 'tumo-chip' + (on ? ' is-on' : '');
      c.textContent = priceLabel(r);
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var q = new URLSearchParams(window.location.search);
        q.delete('filter.v.price.gte');
        q.delete('filter.v.price.lte');
        if (!on) {
          if (r[0]) q.set('filter.v.price.gte', r[0]);
          if (r[1] !== null) q.set('filter.v.price.lte', r[1]);
        }
        go(q);
      });
      wrap.appendChild(c);
    });
    form.parentNode.insertBefore(wrap, form);
  }

  function walkText(root, fn) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(fn);
  }

  function enhance() {
    buildChips();
    var facets = document.getElementById('main-collection-filters') || document;
    if (!isLT) {
      walkText(facets, function (n) {
        var t = n.nodeValue.trim();
        if (EN[t]) n.nodeValue = n.nodeValue.replace(t, EN[t]);
      });
    }
    facets.querySelectorAll('.facet-checkbox__text-label, .facets__label, label').forEach(function (el) {
      if (el.querySelector('.tumo-ori')) return;
      var t = el.textContent.replace(/\(\d+\)/, '').trim();
      Object.keys(ORI).forEach(function (k) {
        if (t.indexOf(k) === 0 && !el.querySelector('.tumo-ori')) {
          var i = document.createElement('span');
          i.className = 'tumo-ori tumo-ori--' + ORI[k];
          i.setAttribute('aria-hidden', 'true');
          el.insertBefore(i, el.firstChild);
        }
      });
    });
    if (isLT) {
      document.querySelectorAll('#ProductCount, #ProductCountDesktop, .product-count__text span').forEach(function (el) {
        var s = el.textContent;
        var r = s.replace(/prekių/g, 'kūrinių').replace(/prekės/g, 'kūriniai').replace(/prekė/g, 'kūrinys');
        if (r !== s) el.textContent = r;
      });
    }
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(enhance, 60); }
  document.addEventListener('DOMContentLoaded', function () {
    enhance();
    var target = document.getElementById('main-collection-filters');
    if (target && window.MutationObserver) {
      new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    }
  });
})();
